import { driver } from 'driver.js';
import type { Driver } from 'driver.js';

export const TOUR_HEADER_BUTTON_SELECTOR = '[data-tour="header-tour-button"]';

export const showProductTourFarewell = async (
  waitForElement: (
    selector: string,
    attempts?: number,
    intervalMs?: number
  ) => Promise<Element | null>,
  onClosed?: () => void
): Promise<Driver | null> => {
  await waitForElement(TOUR_HEADER_BUTTON_SELECTOR, 15, 100);

  const driverObj = driver({
    popoverClass: 'sellyt-driver-popover',
    showButtons: ['next', 'close'],
    nextBtnText: 'Got it',
    doneBtnText: 'Got it',
    allowClose: true,
    overlayClickBehavior: 'close',
    steps: [
      {
        element: TOUR_HEADER_BUTTON_SELECTOR,
        popover: {
          title: 'Tour paused',
          description:
            'Use the map icon in the top bar anytime to walk through the dashboard again and see what each section does.',
          side: 'bottom',
          align: 'end',
        },
      },
    ],
    onNextClick: () => {
      driverObj.destroy();
    },
    onCloseClick: () => {
      driverObj.destroy();
    },
    onDestroyed: () => {
      onClosed?.();
    },
  });

  driverObj.drive();
  return driverObj;
};
